<div class="d-flex flex-col form-section">
    <div class="section-header">{{ sectionLabel }}</div>
    <div class="section-content">
        <ng-content></ng-content>
    </div>
</div>
